export default "__VITE_ASSET__Bl$uSDaK__"